const NavBarLogo = (): JSX.Element => {
  return (
    <div className="nav-bar-logo">
      <div className="nav-bar-logo__letter-c-outline">
        <div className="nav-bar-logo__letter-c-inline" />
      </div>
      <div className="nav-bar-logo__letter-g-outline">
        <div className="nav-bar-logo__letter-g-inline">
          <div className="nav-bar-logo__letter-g-box">
            <div className="nav-bar-logo__letter-g-box2" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavBarLogo;
